import React, { useEffect, useRef, useState } from "react";
import "./BybAnalysis.css";
// import Analysis from "../../../assets/selfaudit/images/analysis.jpeg";
import position from "../../../assets/selfaudit/images/position.svg";
import strength from "../../../assets/selfaudit/images/strength.svg";
import unique from "../../../assets/selfaudit/images/unique.svg";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import React from "react";

gsap.registerPlugin(ScrollTrigger);

function BybAnalysis({ onVideoComplete }) {
  const videoRef = useRef(null);
  const sectionRef = useRef(null);
  const hasPlayed = useRef(false); // Track if the video has already played
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    const section = sectionRef.current;

    if (!video || !section) return;

    // ScrollTrigger to autoplay video when section hits the top
    const handleScrollTrigger = () => {
      ScrollTrigger.create({
        trigger: section,
        start: "top top", // Trigger when the section hits the top
        onEnter: () => {
          if (!hasPlayed.current) {
            video.play(); // Play the video
            hasPlayed.current = true; // Mark as played
          }
        },
      });
    };

    // Ensure video readiness
    if (video.readyState >= 2) {
      handleScrollTrigger();
    } else {
      video.addEventListener("loadedmetadata", handleScrollTrigger);
    }

    // Ensure the video stops naturally at its end
    const handleVideoEnd = () => {
      video.pause(); // Pause the video when it ends
      video.controls = false; // Ensure no replay controls are shown
      if (onVideoComplete) onVideoComplete(); // Optional callback if needed
    };

    video.addEventListener("ended", handleVideoEnd);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      video.removeEventListener("loadedmetadata", handleScrollTrigger);
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, [onVideoComplete]);

  const textRef = useRef(null);

  // Intersection Observer for fade-in text
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting); // Set visibility based on intersection
      },
      {
        threshold: 0.5, // Trigger when 50% of the element is visible
      }
    );

    const textElement = textRef.current;
    if (textElement) observer.observe(textElement);

    return () => {
      if (textElement) observer.unobserve(textElement);
    };
  }, []);

  const [systemInfo, setSystemInfo] = useState({
    platform: "",
    userAgent: "",
    cpuCores: 0,
  });

  useEffect(() => {
    const fetchSystemInfo = () => {
      const platform = navigator.platform || 'Unknown';
      const userAgent = navigator.userAgent || 'Unknown';
      const cpuCores = navigator.hardwareConcurrency || 0; // Get number of CPU cores
      setSystemInfo({ platform, userAgent, cpuCores });
    };

    fetchSystemInfo();
  }, []);

  

  useEffect(() => {
    const detectMacArchitecture = () => {
     const check_list =   document.body.querySelector('.check_list');
     const bybAnalysis =   document.body.querySelector('.byb-analysis');
     const bybAudit =   document.body.querySelector('.byb-audit');
     const check_list_believe =   document.body.querySelector('.check_list.byb_believe');
     const panel =   document.body.querySelector('.panel.red');
     const legacy =   document.body.querySelector(' .legacy-content');
     const description_panel =   document.body.querySelector('.description.panel');
     const bybsurveydeck =   document.body.querySelector('.bybsurveydeck');

     
    
      const body = document.body;
      
      const { platform, cpuCores } = systemInfo;

      if (platform.includes('Win')) {
        // legacy.style.backgroundColor ="brown"
        body.style.backgroundColor = 'rgb(7 26 40)'; // Windows
        check_list.style.background ="rgb(7 26 40)"
        bybAnalysis.style.background ="rgb(7 26 40)"
        bybAudit.style.background="rgb(7 26 40)"
        check_list_believe.style.background="rgb(7 26 40)"
        panel.style.background="rgb(7 26 40)"
        legacy.style.background="rgb(7 26 40)"
        description_panel.style.background="rgb(7 26 40)"
        bybsurveydeck.style.background="rgb(7 26 40)"
        
        // check_list_believe
      }
       else if (platform.includes('Mac'))
         {  
        if (cpuCores >= 8) {
          body.style.backgroundColor = 'hwb(202.33deg 0.78% 82.35%)';
          check_list.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAnalysis.style.background ="hwb(202.33deg 0.78% 82.35%)"
          bybAudit.style.background ="hwb(202.33deg 0.78% 82.35%)"// Mac M Series (ARM64)
          panel.style.background="hwb(202.33deg 0.78% 82.35%)"
          legacy.style.background="hwb(202.33deg 0.78% 82.35%)"
          description_panel.style.background="hwb(202.33deg 0.78% 82.35%)"
          check_list_believe.style.background="hwb(202.33deg 0.78% 82.35%)"
          bybsurveydeck.style.background="hwb(202.33deg 0.78% 82.35%)"

        } else {
          body.style.backgroundColor = 'hwb(204.29deg 1.18% 82.35%)'; // Mac Intel
          check_list.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAnalysis.style.background ="hwb(204.29deg 1.18% 82.35%)"
          bybAudit.style.background ="hwb(204.29deg 1.18% 82.35%)"
          panel.style.background="hwb(204.29deg 1.18% 82.35%)"
          legacy.style.background="hwb(204.29deg 1.18% 82.35%)"
          description_panel.style.background="hwb(204.29deg 1.18% 82.35%)"
          check_list_believe.style.background="hwb(204.29deg 1.18% 82.35%)"
          bybsurveydeck.style.background="hwb(204.29deg 1.18% 82.35%)"


        }
      } 
   
    };

    detectMacArchitecture();
  }, [systemInfo]); // Added systemInfo as a dependency to useEffect


  return (
    <>
      <section className="byb-analysis" ref={sectionRef}>
        <div className="container">
          <div className="byb-analysis-header">
            <p
              ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}
            >
              IN KIT – COMPETITIVE ANALYSIS TOOL
            </p>
            <h1><span className="d-lg-block d-line d-md-block">Knowing Where Others Blend in,</span> Is When You Stand Out.</h1>
          </div>
        </div>

        {/* Video Section */}
        <div
          className="vision-section"
          // style={{
          //   height: "100vh", 
          //   overflow: "hidden", 
          // }}
        >
          <div
            className="video-container"
       
          >
            <video
              ref={videoRef}
              className="vision-video desktop_show"
              muted
              playsInline
              preload="metadata"
              src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book4.webm"
            />
          </div>
          <img
            src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book4.svg"
            className="show_mob w-100" width="720" height="720" loading="lazy" decoding="async"
            alt="Knowing Where Brand"
          />
        </div>

        {/* Bottom Content */}
        <div className="container">
          <div className="byb-analysis-bottom">
            <div className="byb-analysis-bottom-p">
              <p>
                Leverage insights from your competitors’ position to
                <span style={{ color: "white" }}> gauge yourself in the market.</span>
              </p>
            </div>
            <div className="byb-analysis-bottom-paras">
              <div className="bottom-paras-one">
                <img src={unique} alt="Unique Icon" />
                <p>
                  Assess your brand's{" "}
                  <span style={{ color: "white" }}>uniqueness and market fit</span>{" "}
                  through competitive positioning.
                </p>
              </div>
              <div className="bottom-paras-two">
                <img src={strength} alt="Strength Icon" />
                <p>
                  Identify{" "}
                  <span style={{ color: "white" }}>
                    strengths, weaknesses, opportunities, and threats
                  </span>{" "}
                  for strategic clarity.
                </p>
              </div>
              <div className="bottom-paras-three">
                <img src={position} alt="Position Icon" />
                <p>
                  Leverage the knowledge of <span style={{ color: "white" }}>
                    competitor landscape to position your brand effectively.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default BybAnalysis;
